import React, { useEffect } from "react";

import { useTheme } from "../theme/ThemeContext";

const NotificationPopup = ({
    type = "success",
    message = "",
    onClose = () => { },
    duration = 3000,
    title = "",
    show = false,

}) => {
    const { theme } = useTheme();
    useEffect(() => {
        if (show && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    if (!show) return null;

    const icons = {
        success: "✓",
        error: "✗",
        warning: "⚠",
        info: "ℹ"
    };

    const titles = {
        success: "Success!",
        error: "Error!",
        warning: "Warning!",
        info: "Information"
    };

    const popupTitle = title || titles[type];

    const isDark = theme === "dark";

    const styles = {
        popup: {
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 10000,
            minWidth: "300px",
            maxWidth: "400px",
            background: isDark ? "#2c3e50" : "white",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            animation: "slideIn 0.3s ease-out",
            overflow: "hidden"
        },
        success: { borderLeft: "4px solid #28a745" },
        error: { borderLeft: "4px solid #dc3545" },
        warning: { borderLeft: "4px solid #ffc107" },
        info: { borderLeft: "4px solid #17a2b8" },

        content: {
            display: "flex",
            alignItems: "flex-start",
            padding: "16px",
            gap: "12px"
        },

        icon: {
            fontSize: "20px",
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
        },

        successIcon: { backgroundColor: "#d4edda", color: "#155724" },
        errorIcon: { backgroundColor: "#f8d7da", color: "#721c24" },
        warningIcon: { backgroundColor: "#fff3cd", color: "#856404" },
        infoIcon: { backgroundColor: "#d1ecf1", color: "#0c5460" },

        text: { flex: 1 },

        title: {
            margin: "0 0 4px 0",
            fontSize: "16px",
            fontWeight: 600,
            color: isDark ? "#ecf0f1" : "#222"
        },

        message: {
            margin: 0,
            fontSize: "14px",
            lineHeight: 1.4,
            color: isDark ? "#ecf0f1" : "#333"
        },

        close: {
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: isDark ? "#bdc3c7" : "#999",
            padding: 0,
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
        }
    };

    return (
        <div style={{ ...styles.popup, ...styles[type] }}>
            <div style={styles.content}>
                <div style={{ ...styles.icon, ...styles[`${type}Icon`] }}>
                    {icons[type]}
                </div>

                <div style={styles.text}>
                    <h4 style={styles.title}>{popupTitle}</h4>
                    <p style={styles.message}>{message}</p>
                </div>

                <button style={styles.close} onClick={onClose}>
                    &times;
                </button>
            </div>

            <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default NotificationPopup;
